import Home from "../../../components/Home/Home"
import {sidebarItems} from "../../../utils/sidebarItems";

const AdministrativeHome = () => {
    return (
        <Home navigationItems={sidebarItems.administrative}/>
    )
}

export default AdministrativeHome;